import React from 'react'
import Form from '../../components/Form'
import fields, { ProposalFormData } from './fields'
import { toast } from 'react-toastify'
import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import Realty from '../../models/Realty'

interface Props {
  initialValues: ProposalFormData
  onUpdated: () => void
  realty: Realty
}

const ProposalForm: React.FC<Props> = ({ initialValues, onUpdated, realty }) => {
  const { request } = useRequest()

  return (
    <Form<ProposalFormData>
      buttonLabel="Fazer Proposta"
      horizontal
      fields={fields}
      initialValues={initialValues}
      keys={[
        'value',
      ]}
      onSubmit={data => {
        const newValue = Number.parseFloat(data.value.toString().split(' ').join(''))
        handleFormSubmit({
          request: request({
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/proposals`,
            data: {
              realty_id: realty.id,
              amount: newValue,
            },
          }),
          onValidationErrors: () => {
            toast.error('Erros de validacao.')
          },
          onSuccess: ({ data }) => {
            console.log(data)
            if(data.message && !data.success) {
              toast.error(data.message )
            } else {
              toast.success('Proposta enviada com sucesso!')
              onUpdated()
            }
          },
          onFailure: () =>{
            toast.error('Erro ao salvar proposta')
          },
        })
      }}
    />
  )
}

export default ProposalForm
